export const SkillsData = [
    {
        course_name : "Python",
        progress : "Advance",
        star : 4,
        progress_bar : 80,
        color : "#00B4DB",
        image : "http://icons.iconarchive.com/icons/cornmanthe3rd/plex/512/Other-python-icon.png"
    },
    {
        course_name : "Javascript(ES6)",
        progress : "Advance",
        star : 4,
        progress_bar : 80,
        color : "#FFF200",
        image : "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1200px-Unofficial_JavaScript_logo_2.svg.png"
    },
    {
        course_name : "ReactJs",
        progress : "Advance",
        star : 4,
        progress_bar : 85,
        color : "#00B4DB",
        image : "https://codeguida.com/media/post_title/React.js_logo.svg_fjk2YxB.png"
    },
    {
        course_name : "Firebase",
        progress : "Intermediate",
        star : 3,
        progress_bar : 60,
        color : "#FDC830",
        image : "https://avatars0.githubusercontent.com/u/1335026?v=3&s=280"
    },
    {
        course_name : "C/C++",
        progress : "Advance",
        star : 4,
        progress_bar : 85,
        color : "#0052d4",
        image : "https://sdtimes.com/wp-content/uploads/2018/03/cpppp.png"
    },
    {
        course_name : "NodeJs",
        progress : "Intermediate",
        star : 3,
        progress_bar : 75,
        color : "#96c93d",
        image : "assets/images/nodejs.svg"
    },
    {
        course_name : "Mongo DB",
        progress : "Intermediate",
        star : 3,
        progress_bar : 70,
        color : "#1E9600",
        image : "https://media.glassdoor.com/sqll/433703/mongodb-squarelogo-1407269491216.png"
    }
]
